import { ZoneFormCache } from '../types'
import { DEFAULT_FRONT_DUST_SUPPRESSION, DEFAULT_SCRUBBER_BRUSH_SPEED, DEFAULT_TURBINE_SPEED } from 'utils/constants'
import { ICleaningZone, IZone } from 'utils/interfaces'

export const resolveZoneSetup = (cache: ZoneFormCache | undefined, zoneToUse: IZone | undefined) => {
  return cache?.swathSequenceMode !== undefined ||
    cache?.bordersNum !== undefined ||
    cache?.maxEdgeAngle !== undefined ||
    cache?.maxEdgeAngleForBorders !== undefined
    ? {
        swath_sequence_mode: cache.swathSequenceMode ?? 0,
        borders_num: cache.bordersNum ?? 0,
        main_thresholds: {
          max_edge_angle: cache.maxEdgeAngle ?? 60,
          max_edge_angle_for_borders: cache.maxEdgeAngleForBorders ?? 100,
        },
      }
    : (zoneToUse as ICleaningZone)?.properties?.setup || {
        swath_sequence_mode: 0,
        borders_num: 0,
        main_thresholds: {
          max_edge_angle: 60,
          max_edge_angle_for_borders: 100,
        },
      }
}

export const resolveZoneEquipmentSetup = (cache: ZoneFormCache | undefined, zoneToUse: IZone | undefined) => {
  return cache?.turbineSpeed !== undefined ||
    cache?.frontDustSuppression !== undefined ||
    cache?.scrubberBrushSpeed !== undefined
    ? {
        turbine_speed: cache.turbineSpeed ?? DEFAULT_TURBINE_SPEED,
        front_dust_suppression: cache.frontDustSuppression ?? DEFAULT_FRONT_DUST_SUPPRESSION,
        scrubber_brush_speed: cache.scrubberBrushSpeed ?? DEFAULT_SCRUBBER_BRUSH_SPEED,
      }
    : (zoneToUse as ICleaningZone)?.properties?.equipment_setup || {
        turbine_speed: DEFAULT_TURBINE_SPEED,
        front_dust_suppression: DEFAULT_FRONT_DUST_SUPPRESSION,
        scrubber_brush_speed: DEFAULT_SCRUBBER_BRUSH_SPEED,
      }
}
